import React, { useEffect, useState, useRef } from 'react'
import { API, graphqlOperation } from 'aws-amplify'
import Suggestions from './Suggestions'
import Input from 'antd/lib/input'
import Spin from 'antd/lib/spin'
import useOutsideClick from '../../hooks/useClickOutside'
import { useGenerateAdminHSK } from '../../customHooks'
import { capitalizeEachWord } from '../../lib/stringOperations'

const { Search } = Input;

const styles = {
    container: {
        width: '100%',
        position: 'relative'
    },
    error: {
        display: 'block',
        textAlign: 'center',
        color: 'red'
    },
    notFound: {
        width: '100%',
        height: '100%',
        display: 'block',
        textAlign: 'center',
        wordWrap: 'break-all',
        whiteSpace: 'normal'
    },
    // input: {
    //     marginTop: 15
    // },
    suggestionBox: {
        backgroundColor: 'white',
        width: '100%',
        boxShadow: 'rgba(0, 0, 0, 0.12) 0px 2px 10px, rgba(0, 0, 0, 0.16) 0px 2px 5px',
        borderRadius: 5,
        marginTop: -12,
        textAlign: 'center'
    }
}

const operation = `query search($searchTerm: String, $d1: String) {
    search(searchTerm: $searchTerm, d1: $d1) {
      ... on Occupant {
        pk
        sk
        d1
        d2
        firstName
        lastName
        building
        tenant
        workPhone {
            number
            extension
        }
        email
        __typename
      }
  }
}`

const SearchInput = ({ onClick }) => {
    const ref = useRef()

    const hsk = useGenerateAdminHSK()

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [search, setSearch] = useState(null)

    useOutsideClick(ref, () => {
        setData([])

    })

    useEffect(() => {
        if(!search) {
            setData([])
        }
    }, [search])

    async function fetchData(term) {
        if(term.length === 0) {
            return null
        }
        
        try {
            setLoading(true)
            const response = await API.graphql(graphqlOperation(operation, { d1: hsk, searchTerm: term }))
            if (response.data.search) {
                setData(response.data.search)
            }
        } catch (err) {
            console.error("error: ", err)
        } finally {
            setLoading(false)
        }
    }

    const onSelect = (item) => {
        setData([])
        setSearch(null)
        onClick(item)
    }

    return (
        <div ref={ref} style={styles.container}>
            <Search
                style={styles.input}
                placeholder="Email..."
                autoComplete="off"
                enterButton
                allowClear
                loading={loading}
                onChange={(e) => setSearch(e.target.value)}
                onSearch={value => fetchData(value)}
            />
            {data && <div style={styles.suggestionBox}>
                {loading && <Spin />}
                <Suggestions data={data} onSelect={onSelect} />
            </div>
            }
        </div>
    )
}

export default SearchInput
